import { BibleIndex, BibleChapter } from '../types/bible';
import { mockBibleIndices } from '../data/mockBibleData';

const API_BASE_URL = '/api';

export class BibleApiService {
  /**
   * 성경 인덱스 데이터를 조회합니다.
   */
  static async getBibleIndices(): Promise<BibleIndex[]> {
    try {
      const response = await fetch(`${API_BASE_URL}/bible/indices`);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('성경 인덱스 조회 중 오류가 발생했습니다:', error);
      console.log('CORS 오류로 인해 mock 데이터를 사용합니다.');
      // CORS 오류 시 mock 데이터 반환
      return mockBibleIndices;
    }
  }

  /**
   * 특정 성경의 장(chapter)의 모든 절(verse)을 조회합니다.
   */
  static async getBibleChapter(
    version: string, 
    bookNo: number, 
    chapter: number
  ): Promise<BibleChapter> {
    try {
      const response = await fetch(`${API_BASE_URL}/bible/${version}/${bookNo}/${chapter}`);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const verses = await response.json();
      // API 응답이 배열 형태로 직접 절들을 반환하므로 이를 처리
      return {
        version,
        bookNo,
        bookName: '', // 이 정보는 별도로 가져와야 함
        chapter,
        verses: verses
      };
    } catch (error) {
      console.error('성경 장 조회 중 오류가 발생했습니다:', error);
      throw error;
    }
  }
}
